import React, { useState } from 'react';
import axios from 'axios';

function DemoForm() {
    const [formData, setFormData] = useState({ name: '', lastname: '' });

    const handleChange = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async e => {
        e.preventDefault();
        try {
            await axios.post('http://localhost:5000/submit-form', formData);
            alert('Form submitted!');
        } catch (err) {
            alert('Error submitting form');
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <input name="name" placeholder="First Name" onChange={handleChange} />
            <input name="lastname" placeholder="Last Name" onChange={handleChange} />
            <button type="submit">Submit</button>
        </form>
    );
}

export default DemoForm;
